export default __webpack_public_path__ + "static/media/boletimFocus.e34f5c02.svg";